import React, { ReactNode } from "react";
import { motion } from "framer-motion";
import { LucideIcon } from "lucide-react";

type SettingSectionProps = {
  icon: LucideIcon;
  title: string;
  children: ReactNode;
};

export default function SettingSection({
  icon: Icon,
  title,
  children,
}: SettingSectionProps) {
  return (
    <motion.div
      className="bg-gray-800 bg-opacity-50 backdrop-blur-lg shadow-lg rounded-xl p-6 border border-gray-700"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex items-center mb-4">
        <Icon className="text-indigo-400 mr-4" size={24} />
        <h2 className="text-xl font-semibold text-gray-100">{title}</h2>
      </div>
      {children}
    </motion.div>
  );
}
